import React from "react"
import { Text } from "~components/El"
import { useTheme } from "~/ui/styled"

const SPAM_KEYWORD = "垃圾邮件"

type AuthTipTextProps = {
  text: string
}

/** 认证流程温馨提示：将「垃圾邮件」高亮为红色 */
export function AuthTipText({ text }: AuthTipTextProps) {
  const theme = useTheme()
  const baseStyle = {
    fontSize: theme.fontSizes.md,
    lineHeight: "22px",
    color: theme.colors.secondaryText,
  } as const
  const idx = text.indexOf(SPAM_KEYWORD)

  if (idx === -1) {
    return <Text style={baseStyle}>{text}</Text>
  }

  return (
    <Text style={baseStyle}>
      {text.slice(0, idx)}
      <span style={{ color: theme.colors.danger }}>{SPAM_KEYWORD}</span>
      {text.slice(idx + SPAM_KEYWORD.length)}
    </Text>
  )
}
